var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('home-header'),_c('home-swiper',{attrs:{"list":_vm.swiperList}}),_c('home-icons',{attrs:{"list":_vm.iconList}}),_c('home-recommend',{attrs:{"list":_vm.recommendList}}),_c('home-weekend',{attrs:{"list":_vm.weekendList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }